//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate')
        .directive('placeholderBlock', ['$sce', function($sce) {
          return {
            restrict: 'E',
            scope: {
              image: '@',
              imageHeight: '@',
              title: '@',
              subtitle: '@',
              noBorder: '@',
              boxMargin: '@',
              boxPadding: '@',
              subtitleHtml: '@?',
            },
            replace: true,
            template: '<div ' +
                                'bindonce class="placeholder-block" ' +
                                'bo-class="{ borderless: noBorder }" ' +
                                'bo-style="{ \'margin-top\': boxMargin, \'margin-bottom\': boxMargin,' +
                                    ' \'padding-left\': boxPadding, \'padding-right\': boxPadding }">' +
                              '<div class="pb-centered">' +
                                  '<img class="pb-image" bo-src="image" bo-style="{ height: imageHeight }" />' +
                                  '<div class="pb-title" bo-text="title"></div>' +
                                  '<div class="pb-subtitle" bo-text="subtitle" ng-if="::!subtitleHtml"></div>' +
                                  '<div class="pb-subtitle" ng-bind-html="::trustedSubtitleHtml" ng-if="::!!subtitleHtml"></div>' +
                              '</div>' +
                          '</div>',
            link(scope) {
              if (scope.subtitleHtml) {
                scope.trustedSubtitleHtml = $sce.trustAsHtml(scope.subtitleHtml);
              }
            },
          };
        }],
    );
})();
